import { type InsuranceCorporateIdentity } from "../types";

export function VividaBkkLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M431.011 126.895C418.612 114.78 401.991 108 384.687 108C367.383 108 350.762 114.78 338.363 126.895L251.297 214.383C275.811 238.932 309.03 252.711 343.659 252.692C379.773 252.692 415.935 240.146 436.211 214.383C446.223 201.714 451.228 185.784 450.269 169.642C449.309 153.5 442.452 138.28 431.011 126.895Z"
        fill="#008BD2"
      />
      <path
        d="M344.864 259.871C326.624 259.929 308.554 256.352 291.703 249.349C274.852 242.346 259.556 232.055 246.702 219.075L241.034 213.438L154.542 126.495L62 219.409L247.035 405L405.78 245.922C386.808 255.189 365.966 259.962 344.864 259.871Z"
        fill="#15265A"
      />
    </svg>
  );
}

export const VividaBkk: InsuranceCorporateIdentity = {
  id: "vivida-bkk",
  name: "Vivida BKK",
  logo: VividaBkkLogo,
  backgroundColor: "#E8F0F5",
  textColor: "#000000",
  wildcard: "vivida",
  type: "statutory",
};
